
import React from 'react';
import { useModalCampaigns } from '@/hooks/useModalCampaigns';
import CampaignModal from './CampaignModal';

interface ModalCampaignProviderProps {
  children: React.ReactNode;
}

export const ModalCampaignProvider: React.FC<ModalCampaignProviderProps> = ({ children }) => {
  const { 
    currentCampaign,
    questions,
    showModal,
    userAnswers,
    quizSubmitted,
    quizPassed,
    score,
    attemptNumber,
    currentQuestionIndex,
    dismissModal,
    handleAnswer,
    submitQuiz,
    resetQuiz,
    goToPreviousQuestion,
    goToNextQuestion,
    canDismiss
  } = useModalCampaigns();
  
  return (
    <>
      {children}
      
      <CampaignModal
        campaign={currentCampaign}
        questions={questions}
        open={showModal}
        userAnswers={userAnswers}
        quizSubmitted={quizSubmitted}
        quizPassed={quizPassed}
        score={score}
        attemptNumber={attemptNumber}
        canDismiss={canDismiss}
        onDismiss={dismissModal}
        onAnswer={handleAnswer}
        onSubmit={submitQuiz}
        onReset={resetQuiz}
        currentQuestionIndex={currentQuestionIndex}
        onPrevQuestion={goToPreviousQuestion}
        onNextQuestion={goToNextQuestion}
      />
    </>
  );
};

export default ModalCampaignProvider;
